<template>
    <div class="CFormCheckboxGroup" :class="{ 'flex flex-col': order }">
        <div
            v-for="option in normalizedOptions"
            :key="option.value"
            class="option"
            :style="{ 'order': option.data?.index || 99 }"
        >
            <CFormCheckbox
                :disabled="option.disabled || disabled"
                :model-value="isChecked(option.value)"
                @update:model-value="(checked) => toggleCheckedValue(checked, option.value)"
            >
                {{ option.label }}
            </CFormCheckbox>
        </div>
    </div>
</template>

<script setup lang="ts">
import CFormCheckbox from '@/components/ui/CFormCheckbox.vue'
import { type Extractor, normalizeOptions, type Option } from '@/utils/normalizeOption'
import { computed } from 'vue'

const props = withDefaults(
    defineProps<{
        modelValue?: Option['value'][]
        options: any[] | Record<PropertyKey, any>
        optionLabelKey?: Extractor
        optionValueKey?: Extractor
        optionDisabledKey?: Extractor
        disabled?: boolean
        order?: boolean
    }>(),
    {
        modelValue: () => [],
        disabled: false,
        optionLabelKey: undefined,
        optionValueKey: undefined,
        optionDisabledKey: undefined,
        order: false
    }
)

const emit = defineEmits<{
    (e: 'update:modelValue', value: Option['value'][]): void
}>()

const normalizedOptions = computed((): Option[] => {
    return normalizeOptions(props.options, {
        value: props.optionValueKey,
        label: props.optionLabelKey,
        disabled: props.optionDisabledKey
    })
})

function isChecked(value: Option['value']): boolean {
    return (props.modelValue || []).includes(value)
}

function toggleCheckedValue(checked: boolean, value: Option['value']) {
    const currentValue = props.modelValue || []
    const newValue = [...currentValue]
    const index = newValue.indexOf(value)

    if (checked && index === -1) {
        newValue.push(value)
    } else if (!checked && index !== -1) {
        newValue.splice(index, 1)
    }

    emit('update:modelValue', newValue)
}
</script>
